/* Real Food - correcciones observaciones cliente (05-10 y 09-10)
   Se carga desde snippets/icon-cart.liquid con guard anti-duplicado. */
(function () {
  if (window.__rfFixes) return;
  window.__rfFixes = true;

  var HEART = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  /* ---- 1) "Que necesita tu cuerpo hoy?": un punto por categoria ---- */
  function fixCategoryDots(root) {
    var grid = root.querySelector('.featured-categories__grid');
    var wrap = root.querySelector('.featured-categories__dots');
    if (!grid || !wrap) return;
    var cards = grid.querySelectorAll('.category-card');
    if (!cards.length || wrap.dataset.rfFixed === '1') return;
    wrap.dataset.rfFixed = '1';

    wrap.innerHTML = '';
    for (var i = 0; i < cards.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'featured-categories__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('data-rf-dot', i);
      b.setAttribute('aria-label', 'Ir a la categoria ' + (i + 1));
      wrap.appendChild(b);
    }
    var dots = Array.prototype.slice.call(wrap.children);
    root.updateActiveDot = function () {};
    root.scrollToPage = function () {};

    function step() {
      var r = cards[0].getBoundingClientRect();
      var st = window.getComputedStyle(grid);
      var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
      return (r.width + gap) || grid.clientWidth;
    }
    function setActive(i) {
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === i);
    }
    function current() {
      var s = step();
      if (!s) return 0;
      var max = grid.scrollWidth - grid.clientWidth;
      if (max > 0 && grid.scrollLeft >= max - 1) return dots.length - 1;
      return Math.max(0, Math.min(dots.length - 1, Math.round(grid.scrollLeft / s)));
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var s = step();
        var max = grid.scrollWidth - grid.clientWidth;
        var left = i * s;
        if (max > 0) left = Math.min(left, max);
        grid.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
      });
    });
    var t;
    grid.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setActive(current()); }, 60);
    }, { passive: true });
    setActive(current());
  }

  /* ---- 2) "Comparar" -> corazon de lista de deseos, con etiqueta "Añadir" ---- */
  function compararACorazon() {
    var botones = document.querySelectorAll('.compare-btn');
    for (var i = 0; i < botones.length; i++) {
      var viejo = botones[i];
      if (!viejo.closest('.product-card-item')) continue;
      var nuevo = viejo.cloneNode(false);
      nuevo.setAttribute('data-rf-heart', '1');
      nuevo.classList.remove('compare-btn');
      nuevo.classList.add('wishlist-btn');
      nuevo.setAttribute('aria-label', 'Añadir a la lista de deseos');
      nuevo.setAttribute('data-tooltip', 'Añadir');
      nuevo.removeAttribute('title');
      nuevo.innerHTML = HEART;
      viejo.parentNode.replaceChild(nuevo, viejo);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-rf-heart="1"]') : null;
    if (!btn) return;
    var card = btn.closest('.product-card-item');
    if (!card || !window.themeWishlist) return;
    e.preventDefault();
    e.stopPropagation();
    window.themeWishlist.toggle({
      handle: card.dataset.productHandle,
      id: card.dataset.productId,
      title: card.dataset.productTitle,
      price: card.dataset.productPrice,
      compare_price: card.dataset.productComparePrice || null,
      image: card.dataset.productImage,
      url: card.dataset.productUrl,
      variant_id: card.dataset.variantId
    });
  }, true);

  /* ---- 3) Filtro de precio: campos escribibles y sincronizados con el slider ---- */
  function fixPriceInputs() {
    var cajas = document.querySelectorAll('.price-slider-container');
    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      if (c.dataset.rfPrice === '1') continue;
      c.dataset.rfPrice = '1';
      (function (cont) {
        var rMin = cont.querySelector('.range-min');
        var rMax = cont.querySelector('.range-max');
        var iMin = cont.querySelector('.price-input-min');
        var iMax = cont.querySelector('.price-input-max');
        var track = cont.querySelector('.slider-track');
        if (!rMin || !rMax || !iMin || !iMax) return;
        iMin.removeAttribute('readonly');
        iMax.removeAttribute('readonly');
        var tope = parseFloat(rMin.max) || 200;

        function pintar() {
          var a = parseFloat(rMin.value), b = parseFloat(rMax.value);
          if (!track) return;
          track.style.left = (a / tope * 100) + '%';
          track.style.right = (100 - (b / tope * 100)) + '%';
        }
        function desdeCampos() {
          var a = parseFloat(iMin.value);
          var b = parseFloat(iMax.value);
          if (isNaN(a)) a = 0;
          if (isNaN(b)) b = tope;
          a = Math.max(0, Math.min(tope, a));
          b = Math.max(0, Math.min(tope, b));
          if (a > b) a = b;
          iMin.value = a; iMax.value = b;
          rMin.value = a; rMax.value = b;
          pintar();
          var form = cont.closest('form');
          if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
        }
        iMin.addEventListener('change', desdeCampos);
        iMax.addEventListener('change', desdeCampos);
        /* Un clic basta: el campo recibe el foco y el numero queda seleccionado,
           asi se reemplaza al escribir en vez de sumarse al valor anterior. */
        [iMin, iMax].forEach(function (campo) {
          var recien = false;
          campo.addEventListener('focus', function () { recien = true; campo.select(); });
          campo.addEventListener('mouseup', function (ev) {
            if (recien) { ev.preventDefault(); campo.select(); recien = false; }
          });
          campo.addEventListener('blur', function () { recien = false; });
          var caja = campo.closest('.price-input-box');
          if (caja) caja.addEventListener('mousedown', function (ev) {
            if (ev.target !== campo) { ev.preventDefault(); campo.focus(); }
          });
        });
        [iMin, iMax].forEach(function (campo) {
          campo.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter') { ev.preventDefault(); desdeCampos(); }
          });
        });
      })(c);
    }
  }

  /* ---- 4) Pop-up 10%: el codigo solo se muestra despues de registrar el correo ----
     Usa el formulario nativo de clientes de Shopify (crea el cliente con la
     etiqueta popup-10 y consentimiento de marketing). El descuento ya es de un
     solo uso por cliente. */
  var RF_CODE = 'BIENVENIDO10';
  function fixPopup() {
    var pop = document.querySelector('.announcement-popup-overlay');
    if (!pop || pop.dataset.rfForm === '1') return;
    pop.dataset.rfForm = '1';
    var ok = /customer_posted=true/.test(window.location.search);
    var desc = pop.querySelector('.announcement-popup-description');
    var btns = pop.querySelector('.announcement-popup-buttons');

    if (desc) {
      desc.innerHTML = ok
        ? '<p>¡Gracias por registrarte! Usa este código en tu primera compra:</p><p class="rf-pop-code">' + RF_CODE + '</p>'
        : '<p>Déjanos tu correo y te mostramos al instante tu código de 10% para tu primera compra. Además recibirás novedades, recetas y promociones exclusivas.</p>';
    }
    if (btns) {
      if (ok) {
        btns.innerHTML = '<a href="/collections/all" class="announcement-popup-btn announcement-popup-btn-primary">Ir a la tienda</a>';
      } else {
        var form = document.createElement('form');
        form.method = 'post';
        form.action = '/contact#rf-popup';
        form.id = 'rf-popup';
        form.className = 'rf-pop-form';
        form.setAttribute('accept-charset', 'UTF-8');
        form.innerHTML =
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="newsletter,popup-10">' +
          '<input type="email" name="contact[email]" class="rf-pop-input" required placeholder="Tu correo electrónico" autocomplete="email" aria-label="Correo electrónico">' +
          '<div class="announcement-popup-buttons">' +
          '<button type="submit" class="announcement-popup-btn announcement-popup-btn-primary">Quiero mi 10%</button>' +
          '<button type="button" class="announcement-popup-btn announcement-popup-btn-secondary" data-rf-close>Ahora no</button>' +
          '</div>';
        btns.parentNode.replaceChild(form, btns);
      }
    }
    pop.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('[data-rf-close], a.announcement-popup-btn-secondary') : null;
      if (!c) return;
      e.preventDefault();
      var x = pop.querySelector('[data-close-popup]');
      if (x) x.click();
    });
    if (ok) {
      setTimeout(function () {
        pop.classList.add('active');
        document.body.style.overflow = 'hidden';
      }, 300);
    }
  }

  function run() {
    var nodes = document.querySelectorAll('featured-categories-component');
    for (var i = 0; i < nodes.length; i++) fixCategoryDots(nodes[i]);
    compararACorazon();
    fixPriceInputs();
    fixPopup();
    if (window.themeWishlist && window.themeWishlist.updateUI) {
      try { window.themeWishlist.updateUI(); } catch (err) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  var obs = new MutationObserver(function () {
    clearTimeout(window.__rfObsT);
    window.__rfObsT = setTimeout(run, 150);
  });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });
})();
